import Repository from "../Repository";

const resource = "/interactions";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getInteraction(interactionId){
        return Repository.get(`${resource}/${interactionId}`);
    },
    getInteractionTemplates(){
        return Repository.get(`${resource}?is_template=1`);
    },
    getStandardInteractions(){
        return Repository.get(`${resource}?is_template=1&is_standard=1`);
    },
    createInteraction(json){
        return Repository.post(`${resource}`,json);
    },
    updateInteraction(interactionId,json){
        return Repository.put(`${resource}/${interactionId}`,json);
    },
    copyInteraction(interactionId){
        return Repository.post(`${resource}/${interactionId}/copy`);
    },
    deleteInteraction(interactionId){
        return Repository.delete(`${resource}/${interactionId}`);
    }
}